import { AppointmentModel } from '@devexpress/dx-react-scheduler';
import {
  minutesInHour,
  secondsInMinute,
} from 'helpers/timeConsts';

export default function getWorkingHoursFormat(
  workScheduleData: AppointmentModel[],
) {
  const totalMinutes = workScheduleData.reduce(
    (acc, { timeFrom, timeTo }) => acc + (timeTo - timeFrom) / secondsInMinute,
    0,
  );

  const hours = Math.floor(totalMinutes / minutesInHour);
  const minutes = totalMinutes % minutesInHour;

  if (minutes === 0 && hours === 0) {
    return '0';
  }

  return `${hours}:${minutes.toString().padStart(2, '0')}`;
}
